export default __webpack_public_path__ + "static/park-map-36098147f94f7dee5ddf5e595767ddd0.jpg";